module.exports = __webpack_public_path__ + "img/project_4.737625b2.png";